export default __webpack_public_path__ + "static/media/ic-manual.c5cf75df.webp";